import { render, staticRenderFns } from "./changePhone.vue?vue&type=template&id=68fc7bff&scoped=true&"
import script from "./changePhone.vue?vue&type=script&lang=js&"
export * from "./changePhone.vue?vue&type=script&lang=js&"
import style0 from "./changePhone.vue?vue&type=style&index=0&id=68fc7bff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fc7bff",
  null
  
)

export default component.exports